const PAGE_HEIGHT_IN = 11;
const PAGE_WIDTH_IN = 8.5;

interface PageProps {
  children: React.ReactNode;
  className?: string;
  zoom: number;
  printMiniature?: boolean;
}

export function Page({
  children,
  className = "",
  zoom,
  printMiniature = false,
}: PageProps) {
  const transform = `scale(${zoom})`;
  className = `className ${printMiniature ? "miniature" : "reset-zoom"}`;

  return (
    <div
      className={`pdf-zoom-wrapper page ${className}`}
      style={{
        height: `${PAGE_HEIGHT_IN * zoom}in`,
        width: `${PAGE_WIDTH_IN * zoom}in`,
      }}
    >
      <div
        className="pdf-page"
        style={{
          transformOrigin: "top left",
          transform,
          width: "8.5in",
          height: "11in",
          position: "relative",
          // width: "21.59cm",
          // height: "27.94cm",
        }}
      >
        {children}
      </div>
    </div>
  );
}
